import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class StellenService {
    API_URL = environment.apiUrl;
    stellenangebote: any = [];
    codesystems: any = [];
    lang = 'de';
    mandant = '';
    showPopup = false;
    processId: string;

    typeInitialised = false;
    textFilter = '';
    standortFilter = '';
    abteilungFilter = '';
    typeFilter = '';
    spezialFilter = '';

    constructor(private http: HttpClient) {
    }

    //job offert data
    getStellenangebote(reload: boolean, query: String) {
        if (!reload && this.stellenangebote.length > 0) {
            const promise = new Promise((resolve, reject) => {
                resolve(this.stellenangebote);
            });
            return promise;

        } else {
            const url = this.API_URL + 'jobs?query=' + query;
            return this.http.get(url).toPromise()
                .then((response) => {
                    this.stellenangebote = response;
                    return this.stellenangebote;
                });
        }
    }

    getAnsprechpartner(zustaendig) {
        const url = this.API_URL + 'ansprechpartner?zustaendig=' + zustaendig;
        return this.http.get(url).toPromise()
            .then((response) => {
                return response;
            });
    }

    //Formula meta data
    getCodesystems() {
        if (this.codesystems.length !== 0) {
            const promise = new Promise((resolve, reject) => {
                resolve(this.codesystems);
            });
            return promise;

        } else {
            const url = this.API_URL + 'codesystems';
            return this.http.get(url).toPromise()
                .then((response) => {
                    this.codesystems = response;
                    return this.codesystems;
                });
        }
    }

    bewerberAnlegen(body: object) {
        const url = this.API_URL + 'bewerber';
        return this.http.post(url, body).toPromise()
            .then((response) => {
                return response;
            });
    }

    bewerbungsunterlageAnlegen(parentId: string, form: FormData, headers: HttpHeaders) {
        const url = this.API_URL + 'bewerbungsunterlage?parentId=' + parentId;
        return this.http.post(url, form, {headers: headers}).toPromise()
            .then((response) => {
                return response;
            }, (reason) => {
                return 'error';
            });
    }

    bewerben(body: object) {
        const url = this.API_URL + 'bewerben';
        return this.http.post(url, body).toPromise()
            .then((response) => {
                return response;
            }, (reason) => {
                return 'error';
            });
    }

    email(body: object) {
        const url = this.API_URL + 'email';
        return this.http.post(url, body).toPromise()
            .then((response) => {
                return response;
            }, (reason) => {
                return 'error';
            });
    }

}
